module.exports = __webpack_public_path__ + "static/img/6.805249c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/6.jpg
// module id = +rXb
// module chunks = 1